import { jsx } from 'react/jsx-runtime';
import { useState, useContext } from 'react';
import { WizardBase, WizardBaseContext } from '../WizardBase/WizardBase.js';

function Wizard({
  children,
  onNext,
  onBack,
  onGoToStep,
  onStepChange = () => {},
  ...rest
}) {
  const {
    activeSteps
  } = WizardBase.getSteps(children);
  const [currentStepId, setCurrentStepId] = useState(activeSteps[0]?.props.id);
  function handleNext(step, data) {
    setCurrentStepId(step.id);
    onStepChange?.(step.id);
    onNext?.(step, data);
  }
  function handleBack(step, data) {
    setCurrentStepId(step.id);
    onStepChange?.(step.id);
    onBack?.(step, data);
  }
  function handleGoToStep(step) {
    setCurrentStepId(step.id);
    if (onGoToStep) {
      onGoToStep(step);
    }
  }
  return jsx(WizardBase, {
    onNext: handleNext,
    onBack: handleBack,
    onGoToStep: handleGoToStep,
    activeStepId: currentStepId,
    ...rest,
    children: children
  });
}
Wizard.Step = WizardBase.Step;
Wizard.useWizard = () => useContext(WizardBaseContext);

export { Wizard };
